import { Injectable } from "@angular/core";
import { TimeagoIntl } from "ngx-timeago";
import { LocalStorage } from "./localstorage.helper";

// English language strings
const englishStrings = {
    prefixAgo: undefined,
    prefixFromNow: undefined,
    suffixAgo: 'ago',
    suffixFromNow: 'from now',
    seconds: 'less than a minute',
    minute: 'about a minute',
    minutes: '%d minutes',
    hour: 'about an hour',
    hours: 'about %d hours',
    day: 'a day',
    days: '%d days',
    month: 'about a month',
    months: '%d months',
    year: 'about a year',
    years: '%d years',
    wordSeparator: ' ',
};

// Arabic language strings
function numpf(n: number, a: string[]): string {
    return a[n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5];
}

const arabicStrings = {
    prefixAgo: 'منذ',
    prefixFromNow: 'بعد',
    suffixAgo: undefined,
    suffixFromNow: undefined,
    second: function (value: number) {
        return numpf(value, [
            'أقل من ثانية',
            'ثانية واحدة',
            'ثانيتين',
            '%d ثوانٍ',
            '%d ثانية',
            '%d ثانية',
        ]);
    },
    seconds: function (value: number) {
        return numpf(value, [
            'أقل من ثانية',
            'ثانية واحدة',
            'ثانيتين',
            '%d ثوانٍ',
            '%d ثانية',
            '%d ثانية',
        ]);
    },
    minute: function (value: number) {
        return numpf(value, [
            'أقل من دقيقة',
            'دقيقة واحدة',
            'دقيقتين',
            '%d دقائق',
            '%d دقيقة',
            'دقيقة',
        ]);
    },
    minutes: function (value: number) {
        return numpf(value, [
            'أقل من دقيقة',
            'دقيقة واحدة',
            'دقيقتين',
            '%d دقائق',
            '%d دقيقة',
            'دقيقة',
        ]);
    },
    hour: function (value: number) {
        return numpf(value, [
            'أقل من ساعة',
            'ساعة واحدة',
            'ساعتين',
            '%d ساعات',
            '%d ساعة',
            '%d ساعة',
        ]);
    },
    hours: function (value: number) {
        return numpf(value, [
            'أقل من ساعة',
            'ساعة واحدة',
            'ساعتين',
            '%d ساعات',
            '%d ساعة',
            '%d ساعة',
        ]);
    },
    day: function (value: number) {
        return numpf(value, [
            'أقل من يوم',
            'يوم واحد',
            'يومين',
            '%d أيام',
            '%d يومًا',
            '%d يوم',
        ]);
    },
    days: function (value: number) {
        return numpf(value, [
            'أقل من يوم',
            'يوم واحد',
            'يومين',
            '%d أيام',
            '%d يومًا',
            '%d يوم',
        ]);
    },
    month: function (value: number) {
        return numpf(value, [
            'أقل من شهر',
            'شهر واحد',
            'شهرين',
            '%d أشهر',
            '%d شهرًا',
            '%d شهر',
        ]);
    },
    months: function (value: number) {
        return numpf(value, [
            'أقل من شهر',
            'شهر واحد',
            'شهرين',
            '%d أشهر',
            '%d شهرًا',
            '%d شهر',
        ]);
    },
    year: function (value: number) {
        return numpf(value, [
            'أقل من عام',
            'عام واحد',
            '%d عامين',
            '%d أعوام',
            '%d عامًا',
        ]);
    },
    years: function (value: number) {
        return numpf(value, [
            'أقل من عام',
            'عام واحد',
            'عامين',
            '%d أعوام',
            '%d عامًا',
            '%d عام',
        ]);
    },
};

@Injectable()
export class MyIntl extends TimeagoIntl {
    constructor() {
        super();
        const lang = LocalStorage.get('lang') || 'en';
        this.strings = lang === 'ar' ? arabicStrings : englishStrings;

        // Optional override of "seconds" message
        this.strings.seconds = lang === 'ar' ? 'الآن' : 'Now';

        this.changes.next();
    }
}
